const prefix =
  "https://raw.githubusercontent.com/O-dik90/Landing_page/master/src/assets/images/products/";

export default [
  {
    image: `${prefix}digital_video/Confidence Premium Night.png`,
    title: "title",
  },
  {
    image: `${prefix}digital_video/Ntrl.png`,
    title: "title",
  },
  {
    image: `${prefix}digital_video/Molto.png`,
    title: "title",
  },
  {
    image: `${prefix}digital_video/Slank.png`,
    title: "title",
  },
  {
    image: `${prefix}digital_video/KUNCIE 1.png`,
    title: "title",
  },
  {
    image: `${prefix}infographic/paddle pop 1.png`,
    title: "title",
  },
  {
    image: `${prefix}infographic/A MILD - VR.png`,
    title: "title",
  },
  {
    image: `${prefix}music_video/DAMARA DE - TRESNOMU LUNGO.png`,
    title: "title",
  },
  {
    image: `${prefix}infographic/A MILD - WEB.png`,
    title: "title",
  },
  {
    image: `${prefix}music_video/DAMARA DE - CRITO MUSTAHIL.png`,
    title: "title",
  },
  {
    image: `${prefix}infographic/BTN PRIORITAS - JUNI.png`,
    title: "title",
  },
  {
    image: `${prefix}infographic/DINKES.png`,
    title: "title",
  },
];
